import { ViaCepDto } from "src/interfaces/ViaCep.Dto";
import api from "./api";

export function BuscarCep(cep: string) {
  return api
    .get<ViaCepDto>("https://viacep.com.br/ws/" + cep + "/json/")
    .then((response) => response.data);
}
